if (!customElements.get('klaviyo-backinstock')) {
  class KlaviyoBackInStock extends HTMLElement {
    static SELECTORS = {
      trigger: '.klaviyo-bis-trigger',
      email: 'input[type="email"]',
      resetEmail: '.backinstock-customer__email-close',
      emailContainer: '.backinstock-customer__email-container',
      variantInput: 'product-form form input[name="id"]',
      popoverClose: '[data-action="close"]',
    };

    static MESSAGES = {
      invalidEmail: 'Veuillez entrer une adresse email valide.',
      success: 'Vous serez notifié par email dès que ce produit sera disponible.',
      error: 'Une erreur est survenue, veuillez réessayer.',
    };

    connectedCallback() {
      this._abort = new AbortController();
      const sig = { signal: this._abort.signal };

      this._trigger = this.querySelector(KlaviyoBackInStock.SELECTORS.trigger);
      this._email = this.querySelector(KlaviyoBackInStock.SELECTORS.email);
      this._resetEmail = this.querySelector(KlaviyoBackInStock.SELECTORS.resetEmail);

      this._trigger?.addEventListener('click', (e) => this._handleSubmit(e), sig);
      this._email?.addEventListener('blur', () => this._isValidEmail(), sig);
      this._resetEmail?.addEventListener('click', (e) => this._clearEmailInput(e), sig);
    }

    disconnectedCallback() {
      this._abort?.abort();
    }

    _isValidEmail() {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const valid = re.test(this._email?.value ?? '');
      if (valid) {
        this._email.classList.remove('input-error');
      } else {
        this._email?.classList.add('input-error');
        this._insertMessage('error', KlaviyoBackInStock.MESSAGES.invalidEmail);
      }
      return valid;
    }

    _handleSubmit(e) {
      e.preventDefault();
      if (!this._isValidEmail()) return;

      this._email.classList.remove('input-error');

      const variantInput = document.querySelector(KlaviyoBackInStock.SELECTORS.variantInput);
      const variantID = variantInput?.value;
      if (!variantID) return;

      const publicApiKey = window.themeVariables?.klaviyo?.publicApiKey;
      if (!publicApiKey) return;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: this._email.value },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantID}`,
              },
            },
          },
        },
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${publicApiKey}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (response.ok) {
            this._insertMessage('success', KlaviyoBackInStock.MESSAGES.success);
            setTimeout(() => {
              this.closest('x-drawer')?.querySelector(KlaviyoBackInStock.SELECTORS.popoverClose)?.click();
            }, 4000);
          } else {
            this._insertMessage('error', KlaviyoBackInStock.MESSAGES.error);
          }
        })
        .catch(() => {
          this._insertMessage('error', KlaviyoBackInStock.MESSAGES.error);
        });
    }

    _insertMessage(type, text) {
      const parent = this._email?.parentNode;
      if (!parent) return;

      parent.querySelector('.klaviyo-bis-message')?.remove();

      const msg = document.createElement('p');
      msg.className = `klaviyo-bis-message klaviyo-bis-message--${type}`;
      msg.textContent = text;
      parent.insertBefore(msg, this._email.nextSibling);

      setTimeout(() => msg.remove(), 5000);
    }

    _clearEmailInput(e) {
      const container = e.currentTarget.closest(KlaviyoBackInStock.SELECTORS.emailContainer);
      Array.from(container?.children ?? []).forEach((child) =>
        child.classList.toggle('visually-hidden')
      );
      this._email.value = '';
      this._email.focus();
    }
  }

  customElements.define('klaviyo-backinstock', KlaviyoBackInStock);
}
